module.exports = __webpack_public_path__ + "img/com.bshg.homeconnect.android.release.a011c3e7.webp";